import { render, staticRenderFns } from "./dashboard-backlog.vue?vue&type=template&id=fed9c43c&"
import script from "./dashboard-backlog.vue?vue&type=script&lang=ts&"
export * from "./dashboard-backlog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports